import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheCageAvalancheIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController:FlowStateController):void {
        SlotGame.apiPlugin.betHandler.zeroBet();
        flowStateController.finish();
    }
}